import useAxios, { mutate } from 'hooks/useAxios'
import React, { useEffect, useState } from 'react'
import * as R from 'ramda'

import CustomerTagInput from '../CustomerTagInput'

export default function CustomerImportTagsInputContainer({ setAdditionalCommaSeparatedTags }) {
  const [selectedTags, setSelectedTags] = useState([])
  useEffect(() => {
    setAdditionalCommaSeparatedTags(selectedTags.map((tag) => tag.name).join(','))
  }, [selectedTags, setAdditionalCommaSeparatedTags])

  const { data: allCustomerTagsData } = useAxios({
    url: 'customers/tag/',
  })

  const { fetch: createTag } = useAxios({
    method: 'post',
    url: 'customers/tag/',
    skip: true,
  })
  function handleCreateTag(tagName) {
    const fakeNewTag = {
      id: -Math.round(Math.random() * 10000),
      name: tagName,
    }
    mutate(
      'customers/tag/',
      (data) => {
        return {
          ...data,
          results: [fakeNewTag].concat(data.results),
        }
      },
      false
    )
    setSelectedTags((selectedTags) => selectedTags.concat(fakeNewTag))
    createTag({
      data: {
        name: tagName,
      },
    }).then((response) => {
      mutate('customers/tag/')
      const newTag = response.data
      setSelectedTags((selectedTags) =>
        selectedTags.filter((tag) => tag.id !== fakeNewTag.id).concat(newTag)
      )
    })
  }

  const { fetch: deleteTag } = useAxios({
    method: 'delete',
    skip: true,
  })
  /** @param {import('../CustomerTagInput').CustomerTag} tagToBeDeleted */
  function handleDeleteTag(tagToBeDeleted) {
    setSelectedTags((selectedTags) => selectedTags.filter((tag) => tag.id !== tagToBeDeleted.id))
    mutate(
      'customers/tag/',
      (state) => {
        return {
          ...state,
          results: state.results.filter((tag) => tag.id !== tagToBeDeleted.id),
        }
      },
      false
    )
    deleteTag({
      url: `customers/tag/${tagToBeDeleted.id}/`,
    }).then(() => {
      mutate('customers/tag/')
    })
  }

  const { fetch: modifyTag } = useAxios({
    method: 'patch',
    skip: true,
  })
  /**
   * @param {import('../CustomerTagInput').CustomerTag} tagToBeModified
   * @param {string} newTagName
   */
  function handleModifyTag(tagToBeModified, newTagName) {
    mutate(
      'customers/tag/',
      (state) => {
        const indexToModify = R.findIndex((tag) => tag.id === tagToBeModified.id, state.results)
        return {
          ...state,
          results: R.update(indexToModify, { ...tagToBeModified, name: newTagName }, state.results),
        }
      },
      false
    )
    modifyTag({
      url: `customers/tag/${tagToBeModified.id}/`,
      data: {
        name: newTagName,
      },
    }).then(() => {
      mutate('customers/tag/')
    })
  }

  if (!allCustomerTagsData) {
    return (
      <CustomerTagInput
        allTags={null}
        loading
        onCreateTag={noop}
        onDeleteTag={noop}
        onModifyTag={noop}
      />
    )
  }

  return (
    <CustomerTagInput
      onChange={setSelectedTags}
      allTags={allCustomerTagsData.results}
      selectedTags={selectedTags}
      onCreateTag={handleCreateTag}
      onDeleteTag={handleDeleteTag}
      onModifyTag={handleModifyTag}
    />
  )
}

function noop() {}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomerImportTagsInput/container.js